var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportAgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1957_1149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3717 19.3392C32.3717 10.8754 25.8042 5.125 18.4967 5.125C11.2663 5.125 4.62174 10.7521 4.62174 19.4317C3.69674 19.9558 3.08008 20.9425 3.08008 22.0833V25.1667C3.08008 26.8625 4.46758 28.25 6.16341 28.25H7.70508V18.8458C7.70508 12.8796 12.5305 8.05417 18.4967 8.05417C24.463 8.05417 29.2884 12.8796 29.2884 18.8458V29.7917H16.9551V32.875H29.2884C30.9842 32.875 32.3717 31.4875 32.3717 29.7917V27.9108C33.2813 27.4329 33.9134 26.4925 33.9134 25.3825V21.8367C33.9134 20.7575 33.2813 19.8171 32.3717 19.3392Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8717 22.0833C14.7232 22.0833 15.4134 21.3931 15.4134 20.5417C15.4134 19.6902 14.7232 19 13.8717 19C13.0203 19 12.3301 19.6902 12.3301 20.5417C12.3301 21.3931 13.0203 22.0833 13.8717 22.0833Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1217 22.0833C23.9732 22.0833 24.6634 21.3931 24.6634 20.5417C24.6634 19.6902 23.9732 19 23.1217 19C22.2703 19 21.5801 19.6902 21.5801 20.5417C21.5801 21.3931 22.2703 22.0833 23.1217 22.0833Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7505 17.5046C27.0105 13.1108 23.1871 9.75 18.5775 9.75C13.9063 9.75 8.88046 13.6196 9.28129 19.6937C13.0892 18.1367 15.9567 14.745 16.7738 10.6133C18.7934 14.6679 22.9405 17.4583 27.7505 17.5046Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1957_1149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportAgent);
export default __webpack_public_path__ + "static/media/support_agent.b785b27a1594856e8947025c50a55064.svg";
export { ForwardRef as ReactComponent };